import { render } from "./ApiDocMethod.vue?vue&type=template&id=5210c7d0"
import script from "./ApiDocMethod.vue?vue&type=script&lang=js"
export * from "./ApiDocMethod.vue?vue&type=script&lang=js"

import "./ApiDocMethod.vue?vue&type=style&index=0&id=5210c7d0&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__